import { KeyValuePair, Typography } from '@automata/ui';

type Props = {
  keyText: string;
  valText: string;
};

const TooltipKeyValuePair = ({ keyText, valText }: Props): JSX.Element => {
  return (
    <KeyValuePair
      name={keyText}
      keyElement={<Typography variant="overline">{keyText}</Typography>}
      valueElement={
        <Typography variant="subtitle1" component="p">
          {valText}
        </Typography>
      }
    />
  );
};

export default TooltipKeyValuePair;
